import { render, staticRenderFns } from "./VOverlayLoader.vue?vue&type=template&id=2484478a&scoped=true&"
import script from "./VOverlayLoader.vue?vue&type=script&lang=js&"
export * from "./VOverlayLoader.vue?vue&type=script&lang=js&"
import style0 from "./VOverlayLoader.vue?vue&type=style&index=0&id=2484478a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2484478a",
  null
  
)

export default component.exports